// extracted by mini-css-extract-plugin
module.exports = {"authWrap":"Authors39b57f23d2acfbce5910b88c461dee61","pageWrapper":"Authorse153c9f78b6f20ca89fbc14b6d7c3018","body":"Authors188f81c5156c7bb987d47d2a141f2828"};